/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {QAvatar,QBadge,QBanner,QBar,QBreadcrumbs,QBreadcrumbsEl,QBtn,QBtnDropdown,QBtnGroup,QBtnToggle,QCard,QCardActions,QCardSection,QCheckbox,QChip,QDate,QDialog,QDrawer,QEditor,QExpansionItem,QField,QFile,QFooter,QHeader,QIcon,QImg,QInput,QItem,QItemLabel,QItemSection,QKnob,QLayout,QLinearProgress,QList,QMenu,QOptionGroup,QPage,QPageContainer,QPagination,QPageSticky,QPopupEdit,QPopupProxy,QRadio,QRouteTab,QScrollArea,QSelect,QSeparator,QSpace,QSpinner,QSpinnerHourglass,QSpinnerGears,QSplitter,QTab,QTable,QTabPanel,QTabPanels,QTabs,QTd,QTh,QToggle,QToolbar,QToolbarTitle,QTooltip,QTr,QTree,QUploader,ClosePopup,Ripple,Cookies,Dialog,Loading,LocalStorage,Notify} from 'quasar'



export default { config: {},components: {QAvatar,QBadge,QBanner,QBar,QBreadcrumbs,QBreadcrumbsEl,QBtn,QBtnDropdown,QBtnGroup,QBtnToggle,QCard,QCardActions,QCardSection,QCheckbox,QChip,QDate,QDialog,QDrawer,QEditor,QExpansionItem,QField,QFile,QFooter,QHeader,QIcon,QImg,QInput,QItem,QItemLabel,QItemSection,QKnob,QLayout,QLinearProgress,QList,QMenu,QOptionGroup,QPage,QPageContainer,QPagination,QPageSticky,QPopupEdit,QPopupProxy,QRadio,QRouteTab,QScrollArea,QSelect,QSeparator,QSpace,QSpinner,QSpinnerHourglass,QSpinnerGears,QSplitter,QTab,QTable,QTabPanel,QTabPanels,QTabs,QTd,QTh,QToggle,QToolbar,QToolbarTitle,QTooltip,QTr,QTree,QUploader},directives: {ClosePopup,Ripple},plugins: {Cookies,Dialog,Loading,LocalStorage,Notify} }

